/* eslint-disable max-lines */
import React, { useRef, useState } from 'react';
import styled from '@emotion/styled';
import { useIsMobile } from '@stores/AppCommonData';
import { mediaQuery, Spacings } from '@styles/index';
import Carousel, { ArrowButton } from 'aquilla/core/molecules/Carousel';
import { segment } from '@actions/analytics';
import { getIntroVideoURL } from '@utils/textHelper';
import { getPathName } from '@cont/CitySpecificOfflineCentres/utils';
import YouTube from '@cont/FreeLesson/externalyoutube';
import MUIDialog from '@material-ui/core/Dialog';
import Typography from 'aquilla/core/atoms/Typography';
import Button from 'aquilla/core/molecules/Button';
import CheckContained from 'aquilla/icons/misc/CheckContained';
import useGoalEventProps from '@hooks/useGoalEventProps';
import Image from '@base/Image';
import {
  OFFLINE_CENTER_CTA,
  OFFLINE_CENTER_ICONS
} from '@cont/NewPreSubscribed/constants';
import { OFFLINE_CENTRE_KNOW_MORE } from '@constants/segment';
import { useRouter } from 'next/router';
import Play from 'aquilla/icons/actions/Play';
import { CENTRE_CITY_SELECTED } from '@cont/CitySpecificOfflineCentres/constants';
import RightChevron from 'aquilla/icons/actions/RightChevron';
import useGoalSpecificCities from '@api/hooks/offlineCentres/useGoalSpecificCities';
import useGoalSpecificCentreLinks from '@api/hooks/offlineCentres/useGoalSpecificCentreLinks';
import useCentreInfo from '@api/hooks/citySpecificOfflineCentres/useCentreInfo';
import CentreSelectionDrawer from './OfflineCentres/OfflineCentreSelectionDrawer';

const data = {
  title: 'Explore Unacademy Centres',
  subscriptionsTitle: 'Centres Subscription',
  subTitle: 'Learn from top educators in your own city',
  benefits: [
    {
      icon: '<url>',
      title: 'In-person classes & doubt solving'
    },
    {
      icon: '<url>',
      title: 'Exclusive quiet spaces for your self-study'
    },
    {
      icon: '<url>',
      title: 'Bonus access to online learning'
    }
  ],
  images: [
    {
      webUrl: 'https://static.uacdn.net/web-cms/uncentre_LP_b041622b0f.jpg'
    },
    {
      webUrl: 'https://static.uacdn.net/web-cms/3_Library_81df92e1bd.jpg'
    },
    {
      webUrl:
        'https://static.uacdn.net/web-cms/2_Experience_Zone_dd71b87574.jpg'
    },
    {
      webUrl:
        'https://static.uacdn.net/web-cms/4_Merchandise_and_Explore_c0fb6a0772.jpg'
    },
    {
      webUrl: 'https://static.uacdn.net/web-cms/5_Classrooms_a10b44fe06.jpg'
    },
    {
      webUrl: 'https://static.uacdn.net/web-cms/6_Unacademy_e9af60ca6e.jpg'
    },
    {
      webUrl:
        'https://static.uacdn.net/web-cms/7_Counselling_Pods_279ce7722f.jpg'
    },
    {
      webUrl:
        'https://static.uacdn.net/web-cms/8_Counselling_Pods_eec603273c.jpg'
    }
  ],
  video: {
    url: 'Vz3F0SgLY3Q'
  }
};

const Container = styled.div`
  margin: ${Spacings.SPACING_12B} auto;
  position: relative;
  width: var(--layout-width);
  ${mediaQuery.uptoTablet} {
    width: 100%;
    margin: ${Spacings.SPACING_8B} auto;
    padding: 0 ${Spacings.SPACING_8B};
  }
  ${mediaQuery.uptoMobile} {
    margin: ${Spacings.SPACING_8B} auto;
    align-items: flex-start;
    gap: ${Spacings.SPACING_5B};
    width: 100%;
    padding: 0 ${Spacings.SPACING_4B};
  }
`;

const HeaderWrapper = styled.div``;

const BlockTitle = styled(Typography)`
  margin-bottom: ${Spacings.SPACING_1B};
`;
const ContentWrapper = styled.div`
  margin-bottom: ${Spacings.SPACING_9B};
  ${mediaQuery.uptoMobile} {
    margin-bottom: ${Spacings.SPACING_5B};
    gap: ${Spacings.SPACING_4B};
  }
`;
const ExploreCentres = styled.div`
  margin-top: ${Spacings.SPACING_8B};
  ${mediaQuery.uptoMobile} {
    gap: ${Spacings.SPACING_5B};
    .header {
      width: 200px;
    }
  }
`;
const CentreLocations = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-top: ${Spacings.SPACING_6B};
  gap: ${Spacings.SPACING_8B};
  ${mediaQuery.uptoMobile} {
    display: grid;
    grid-template-columns: auto auto;
    gap: ${Spacings.SPACING_5B};
  }
`;
const BulletPointsContainer = styled.div`
  display: inline-flex;
  flex-direction: row;
  gap: ${Spacings.SPACING_6B};
  max-width: var(--layout-width);
  margin-top: ${Spacings.SPACING_4B};
  ${mediaQuery.uptoTablet} {
    flex-direction: column;
    gap: ${Spacings.SPACING_3B};
  }
`;
const BulletInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${Spacings.BASE}px;
`;
const LocationCheckInfo = styled.a`
  width: 160px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${Spacings.SPACING_2B};
  padding: ${Spacings.SPACING_2B} 0px ${Spacings.SPACING_2B}
    ${Spacings.SPACING_2B};
  border: 1px solid var(--color-i-divider);
  border-radius: ${Spacings.SPACING_2B};
  cursor: pointer;
  :hover {
    background: var(--color-i-violet-dark-1);
    transition: 'background 300ms ease-in-out';
    border-radius: ${Spacings.SPACING_2B};
  }
  ${({ $morecities }) =>
    $morecities
      ? `cursor: default;
      padding-right: ${Spacings.SPACING_2B};
      border: none;
    :hover {
    background: none;
     }
    `
      : null}
  ${({ $morecities }) => ($morecities ? 'width: auto;' : null)}
`;
const LocationInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  ${mediaQuery.uptoMobile} {
    gap: ${Spacings.SPACING_2};
  }
  ${({ $mWidth }) => ($mWidth ? 'max-width: 105px' : null)}
`;

const ViewAllWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const ButtonsWrapper = styled.div`
  display: flex;
  gap: ${Spacings.SPACING_4B};
  flex-direction: row;
  margin-top: ${Spacings.SPACING_8B};
  ${mediaQuery.uptoMobile} {
    width: 100%;
    flex-direction: column;
    gap: ${Spacings.SPACING_4B};
  }
`;
const StyledButton = styled(Button)`
  width: 157px;
  height: 60px;
  position: absolute;
  left: 16px;
  bottom: 16px;
  z-index: 1;
  padding-left: 16px;
  padding-right: 16px;
  border-radius: 30px;
  border: none;
  ${mediaQuery.uptoMobile} {
    width: 123px;
    height: 36px;
  }
`;
const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  ${mediaQuery.uptoMobile} {
    gap: 11px;
  }
`;
const ImageWrapper = styled.div`
  border-radius: ${Spacings.SPACING_2B};
  position: relative;
  width: var(--layout-width);
  height: 100%;
  ${mediaQuery.uptoTablet} {
    width: calc(100vw - ${Spacings.SPACING_16B});
  }
  ${mediaQuery.uptoMobile} {
    width: calc(100vw - 32px);
  }
  img {
    border-radius: 8px;
    object-fit: cover;
  }
`;
const StyledArrowButton = styled(ArrowButton)`
  z-index: 1;
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  :nth-of-type(2) {
    left: unset;
    right: 16px;
  }
`;
const CarouselContainer = styled.div`
  position: relative;
  width: var(--layout-width);
  aspect-ratio: 150 / 79;
  margin: auto;
  overflow: hidden;
  height: 500px;
  ${mediaQuery.uptoTablet} {
    width: 100%;
    height: auto;
  }
`;
const StyledPlayButton = styled(Play)`
  width: 18px;
  height: 18px;
  align-self: center;
  ${mediaQuery.uptoMobile} {
    width: 11px;
    height: 11px;
  }
`;
const VideoCardContainer = styled.div`
  position: relative;
  /* overflow: hidden; */
  border-radius: ${Spacings.SPACING_2B};
  height: 500px;
  ${mediaQuery.uptoTablet} {
    margin: auto;
    height: auto;
    width: 100%;
  }
`;
const StyledDialog = styled(MUIDialog)`
  &.MuiDialog-root .MuiDialog-container .MuiPaper-root {
    position: absolute;
    background: var(--color-text-primary);
    height: 80%;
    width: 88%;
    max-width: 88%;
    @media only screen and (max-width: 540px) {
      margin: ${Spacings.SPACING_4B} auto;
      height: 30%;
    }
  }
`;
const OfflineCentres = ({ defaultCentreUid }) => {
  const isMobile = useIsMobile();
  const router = useRouter();
  const {
    query: { goalUID }
  } = useRouter();
  const [isCitiesDrawerOpen, setIsCitiesDrawerOpen] = React.useState(false);
  const goalSegmentData = useGoalEventProps({});
  const { centreInfo } = useCentreInfo(goalUID, defaultCentreUid);
  const { centreDeepLinkUrl = '' } = centreInfo ?? {};

  const fallbackRoute = defaultCentreUid
    ? `/goal/-/${goalUID}/centre/-/${defaultCentreUid}`
    : OFFLINE_CENTER_CTA[goalUID];
  const defaultCentreUrl = getPathName(centreDeepLinkUrl, fallbackRoute);

  const knowMoreAboutCentres = (e) => {
    e.preventDefault();
    segment.track(OFFLINE_CENTRE_KNOW_MORE, {
      ...goalSegmentData
    });
    router.push(
      `${defaultCentreUrl}?source=centreBlockFreeGoalPage` ||
        '/offline/centres/'
    );
  };

  const { cityData } = useGoalSpecificCities(goalUID);
  const { offlineCititesMapping } = useGoalSpecificCentreLinks(goalUID);
  const renderCityComponents = (cities = []) => {
    if (!cities.length) return null;
    const activeCities = cities?.filter((city) => city.status === 'Active');
    const initialCities = activeCities?.slice(0, 5);
    const remainingCitiesCount = activeCities?.slice(5).length;

    const handleLinkClicked = (city, centreName) => {
      segment.track(CENTRE_CITY_SELECTED, {
        ...goalSegmentData,
        centre_name: centreName,
        city: city?.name,
        goal_uid: goalUID,
        city_select_flow: 'Free Goal Page',
        selected_city: city?.name
      });
    };
    const getInitialCities = () => {
      return initialCities.map((city) => {
        const cityUid = city?.uid;
        const routeTo = offlineCititesMapping?.[cityUid];
        const centreName = routeTo?.split('centre/')?.[1].split('/')?.[0];
        const cityIcon =
          city?.centres?.[0]?.iconUrl || OFFLINE_CENTER_ICONS?.morecities;

        if (city) {
          return (
            <LocationCheckInfo
              key={cityUid}
              onClick={() => handleLinkClicked(city, centreName)}
              href={routeTo}
            >
              <Image src={cityIcon} width="36" height="36" alt="city" />
              <LocationInfo>
                <Typography variant="h6">{city.name}</Typography>
                <Typography variant="p3" color="var(--color-text-secondary)">
                  {city.state}
                </Typography>
              </LocationInfo>
            </LocationCheckInfo>
          );
        }
        return null;
      });
    };

    const getRemainingCitiesCard = () => {
      const handleViewAllClicked = () => {
        setIsCitiesDrawerOpen(true);
      };
      if (activeCities.length === 1) {
        return (
          <LocationCheckInfo $morecities>
            <Image
              src={OFFLINE_CENTER_ICONS?.viewAll}
              width="36"
              height="36"
              alt="city"
            />
            <LocationInfo $mWidth>
              <Typography variant="h6">Coming soon</Typography>
              <Typography variant="p3" color="var(--color-text-secondary)">
                in more cities
              </Typography>
            </LocationInfo>
          </LocationCheckInfo>
        );
      }
      if (remainingCitiesCount) {
        return (
          <LocationCheckInfo onClick={handleViewAllClicked}>
            <Image
              src={OFFLINE_CENTER_ICONS?.viewAll}
              width="36"
              height="36"
              alt="city"
            />
            <ViewAllWrapper onClick={handleViewAllClicked}>
              <Typography variant="h6">View all</Typography>
              <RightChevron height={20} width={20} />
            </ViewAllWrapper>
          </LocationCheckInfo>
        );
      }
      return null;
    };
    return (
      <>
        {getInitialCities()}
        {getRemainingCitiesCard()}
      </>
    );
  };

  const opts = {
    height: '100%',
    width: '100%',
    playerVars: {
      autoplay: 1,
      showinfo: 0,
      rel: 0
    }
  };
  const [isOpen, setIsOpen] = useState(false);
  const openPlayer = () => {
    setIsOpen(true);
  };

  const closePlayer = () => {
    setIsOpen(false);
  };
  function CarouselItem({ link }) {
    const { webUrl } = link;
    return isMobile ? (
      <ImageWrapper>
        <Image src={webUrl} alt="" layout="fill" />
      </ImageWrapper>
    ) : (
      <ImageWrapper>
        <Image src={webUrl} alt="" layout="fill" />
      </ImageWrapper>
    );
  }
  const carouselRef = useRef(null);
  const [currSlide, setSlide] = useState(0);

  const handleNext = () => {
    if (carouselRef.current) {
      carouselRef.current.onNext();
      setSlide(currSlide + 1);
    }
  };

  const handlePrev = () => {
    if (carouselRef.current) {
      carouselRef.current.onPrev();
      setSlide(currSlide - 1);
    }
  };
  const activeCities = cityData?.filter((city) => city?.status === 'Active');
  return (
    <Container>
      <ContentWrapper>
        <HeaderWrapper>
          <BlockTitle variant={isMobile ? 'h4' : 'h3'}>{data.title}</BlockTitle>
          <Typography
            variant={isMobile ? 'p2' : 'p1'}
            color="var(--color-text-secondary)"
          >
            {data.subTitle}
          </Typography>
        </HeaderWrapper>
        <BulletPointsContainer>
          <BulletInfo>
            <CheckContained
              width={isMobile ? 17 : 20}
              height={isMobile ? 17 : 20}
              color="var(--color-i-blue-23)"
            />
            <Typography variant="p2">{data.benefits[0].title}</Typography>
          </BulletInfo>
          <BulletInfo>
            <CheckContained
              width={isMobile ? 17 : 20}
              height={isMobile ? 17 : 20}
              color="var(--color-i-blue-23)"
            />
            <Typography variant="p2">{data.benefits[1].title}</Typography>
          </BulletInfo>
          <BulletInfo>
            <CheckContained
              width={isMobile ? 17 : 20}
              height={isMobile ? 17 : 20}
              color="var(--color-i-blue-23)"
            />
            <Typography variant="p2">{data.benefits[2].title}</Typography>
          </BulletInfo>
        </BulletPointsContainer>
      </ContentWrapper>
      <VideoCardContainer>
        <CarouselContainer>
          <div>
            <StyledButton variant="secondary" size="large" onClick={openPlayer}>
              <ButtonWrapper>
                <StyledPlayButton />
                <Typography variant="h6">Video tour</Typography>
              </ButtonWrapper>
            </StyledButton>
          </div>
          {/* <ArrowWrapper> */}
          <StyledArrowButton
            type="prev"
            disabled={currSlide === 0}
            onClick={handlePrev}
          />
          <StyledArrowButton
            type="next"
            disabled={currSlide === data.images.length - 1}
            onClick={handleNext}
          />
          {/* </ArrowWrapper> */}
          <Carousel
            ref={carouselRef}
            itemsPerSlide={1}
            variant="single"
            hideButton
          >
            {data.images.map((item) => {
              return <CarouselItem key={' '} link={item} />;
            })}
          </Carousel>
        </CarouselContainer>
        <StyledDialog open={isOpen} onClose={closePlayer}>
          <YouTube
            opts={opts}
            videoId={getIntroVideoURL(data.video.url)}
            onEnd={closePlayer}
            useWrapper={false}
          />
        </StyledDialog>
      </VideoCardContainer>
      <ExploreCentres>
        <Typography className="header" variant={isMobile ? 'h5' : 'h4'}>
          Our Centres are now open across India{' '}
        </Typography>
        {cityData && (
          <CentreLocations>{renderCityComponents(cityData)}</CentreLocations>
        )}
      </ExploreCentres>
      {activeCities?.length > 1 ? (
        <ButtonsWrapper>
          <Button
            label="Know more about Centres"
            variant="primary"
            size="large"
            onClick={knowMoreAboutCentres}
          />
        </ButtonsWrapper>
      ) : null}
      <CentreSelectionDrawer
        goalUID={goalUID}
        isCitiesDrawerOpen={isCitiesDrawerOpen}
        setIsCitiesDrawerOpen={setIsCitiesDrawerOpen}
        cityData={cityData}
      />
    </Container>
  );
};
export default OfflineCentres;
